const selected = state => state.selected

export default {
    selected
}
